function validate_number(value){
    return Number(value) > 0
}


export default {
    'tournament.type_game': {},
    // 'tournament.darts_target_count': {},

    // 'tournament.duration_game': {},

    'settings.split_input': {},

    'tournament.darts_target_count': {
        appearsOn: {
            models: ['settings.split_input'],
            callback: (computed) => {
                // return computed.settings_split_input === 'False'
                return computed.settings_split_input === false
            }
        },
        // validation_message: 'Количество',
        validate: validate_number,
    },

    'tournament.double_selection': {
        required: false,
    },
    
    'tournament.qualifying_stage': {},
    // 'tournament.qualifying_stage_2': {
    //     appearsOn: {
    //         models: ['tournament.double_selection'],
    //         callback: (computed) => {
    //             return computed.tournament_double_selection == true
    //         }
    //     }
    // },
    'tournament.final_stage': {
        appearsOn: {
            models: ['tournament.double_selection'],
            callback: (computed) => {
                return computed.tournament_double_selection == true
            }
        }
    },
    'tournament.qualifying_grid_third_place': {
        required: false,
        appearsOn: {
            models: [
                'tournament.qualifying_stage',
                'tournament.double_selection',
            ],
            callback: (computed) => {
                return computed.tournament_double_selection != true 
                    && computed.tournament_qualifying_stage == 'grid'
            }
        }
    },
    'tournament.qualifying_grid_outside': {
        required: false,
        // appearsOn: {
        //     models: [
        //         'tournament.qualifying_stage',
        //         'tournament.double_selection',
        //     ],
        //     callback: (computed) => {
        //         return computed.tournament_double_selection != true 
        //             && computed.tournament_qualifying_stage == 'grid'
        //     }
        // }
    },
    'tournament.final_grid_third_place': {
        required: false,
        appearsOn: {
            models: [
                // 'tournament.qualifying_stage',
                'tournament.double_selection',
            ],
            callback: (computed) => {
                return computed.tournament_double_selection == true
                // return true
            }
        }
    },
    'tournament.final_grid_outside': {
        required: false,
        // appearsOn: {
        //     models: [
        //         'tournament.qualifying_stage',
        //         'tournament.double_selection',
        //     ],
        //     callback: (computed) => {
        //         return computed.tournament_double_selection != true 
        //             && computed.tournament_qualifying_stage == 'grid'
        //     }
        // }
    },
    'tournament.grid_qualification_rules': {
        appearsOn: {
            models: ['tournament.double_selection'],
            callback: (computed) => {
                return computed.tournament_double_selection == true
            }
        }
    },
    // 'tournament.qualifying_stage': {
    //     appearsOn: {
    //         models: ['tournament.type_game'],
    //         callback: (computed) => {}
    //     }
    // },
    // 'tournament.qualifying_stage_2': {},
    'settings.max_series': {
        appearsOn: {
            models: ['tournament.type_game'],
            callback: (computed) => {
                // const value = ['score'].includes(computed.tournament_type_game)
                const value = ['sector', 'score'].includes(computed.tournament_type_game)
                // return computed.tournament_type_game == 'score'
                return value
            }
        }
    },
    'settings.target_sector': {
        appearsOn: {
            models: ['tournament.type_game'],
            callback: (computed) => {
                // const value = ['sector', 'score'].includes(computed.tournament_type_game)
                const value = ['sector'].includes(computed.tournament_type_game)
                return value
            }
        }
    },
    'tournament.group_count': {
        appearsOn: {
            models: ['tournament.qualifying_stage'],
            callback: (computed) => {
                return computed.tournament_qualifying_stage == 'group'
            },
        },
        validate: validate_number
    },
    'tournament.round_count': {
        appearsOn: {
            models: ['tournament.qualifying_stage'],
            callback: (computed) => {
                return computed.tournament_qualifying_stage == 'round'
            }
        },
        validate: validate_number
    },
    'tournament.participant_count_to_advance_per_qualifying': {
        appearsOn: {
            models: [
                'tournament.double_selection',
                'tournament.qualifying_stage',
            ],
            callback: (computed) => {
                return computed.tournament_double_selection 
                    && computed.tournament_qualifying_stage=='group'
            }
        }
    },
    
}